import { z } from 'zod';
/**
 * One passenger line on a B2B invoice. `amount` is the flight price billed to
 * the B2B client, in cents (the agent enters it manually, euros -> cents).
 */
export const b2bInvoicePassengerSchema = z.object({
    name: z.string().min(1),
    amount: z.number().int().min(0),
});
/**
 * One PNR section on a B2B invoice. `compagnie` / `libelle` are pre-built on the
 * client from the Affidium booking fetched at gather time, so the server stays a
 * pure renderer (no Affidium round-trip at generation). `insurancePrice` (cents)
 * is present only when insurance was toggled on for this PNR.
 */
export const b2bInvoicePnrSectionSchema = z.object({
    compagnie: z.string().default(''),
    insurancePrice: z.number().int().min(0).nullish(),
    libelle: z.string().default(''),
    passengers: z.array(b2bInvoicePassengerSchema).min(1),
    pnr: z.string().min(1),
});
export const generateB2bInvoiceSchema = z.object({
    client: z.object({
        companyName: z.string().min(1),
        contactName: z.string().min(1),
        address: z.string().min(1),
    }),
    /** Optional manual override; auto-generated when absent. */
    invoiceNumber: z.string().optional(),
    pnrSections: z.array(b2bInvoicePnrSectionSchema).min(1),
});
